import hash from './hash'
import ISubscriptionConfig from './interfaces/ISubscriptionConfig'
import MultiplexHost from './MultiplexHost'
import metrics from './sharedMetrics'
import UniqueChannelInstance from './UniqueChannelInstance'

const DEFAULTS = {
  host: '//staging-firehose.ops.pe/',
  ssl: true
}

interface ISubscriptionPublicConfig { // See DEFAULTS above
  host?: string, // Firehose host server, without protocol
  ssl?: boolean, // Should we use secure protocols
  preflight?: ISubscriptionConfig['preflight'], // Called before resubscription - can be used to update a secure token
  params?: ISubscriptionConfig['params'] // Called on subscription to send additional params to firehose (e.g. secure token)
}

const connections: { [key: string]: MultiplexHost } = {}

/**
 * Public interface for firehose-client
 * returns a UniqueChannelInstance which can be used to subscribe to events and unsubscribe when done
 * underlying channel connections will be reused where possible, hence the unique instance to isolate each client
 */
function subscribe (channelPath: string, opts: ISubscriptionPublicConfig = {}): UniqueChannelInstance {
  if (channelPath[0] !== '/') {
    channelPath = `/${channelPath}`
  }

  const options: ISubscriptionConfig = Object.assign({}, DEFAULTS, opts)
  const hostKey = hash(`${options.host}${options.ssl}`)

  if (!connections[hostKey]) {
    connections[hostKey] = new MultiplexHost({
      ssl: options.ssl,
      host: options.host
    })
  }

  const channel = connections[hostKey].openChannel(channelPath, options)

  return new UniqueChannelInstance(channel)
}

subscribe.metrics = metrics

export default subscribe
